import React from 'react';
import { Header } from '@amzn/awsui-components-react-v3/polaris';
// The base no-unused-vars rule does not see type-only uses.
// eslint-disable-next-line no-unused-vars
import ListTable, { ListColumn } from '../../Common/ListTable';
import { ARC_FILTERING_PLACEHOLDER, describeArc } from '../../../utils/arcRows';
import { formatLocale } from '../../../utils/locales';
// eslint-disable-next-line no-unused-vars
import { GeneratedRate } from './pricingModels';

const COLUMNS: ListColumn<GeneratedRate>[] = [
  {
    id: 'sourceLocale',
    header: 'Source locale',
    cell: (rate): string => formatLocale(rate.languagePair.sourceLocale),
  },
  {
    id: 'targetLocale',
    header: 'Target locale',
    cell: (rate): string => formatLocale(rate.languagePair.targetLocale),
  },
  {
    id: 'amount',
    header: 'Amount',
    cell: (rate): string => String(rate.price.amount),
  },
  {
    id: 'currency',
    header: 'Currency',
    cell: (rate): string => rate.price.currency,
  },
];

const PricingModelPreview = ({ rates }: { rates: GeneratedRate[] }): JSX.Element => {
  return (
    <ListTable
      id="pricingModelPreview"
      items={rates}
      columns={COLUMNS}
      filterText={(rate): string => describeArc(rate.languagePair)}
      filteringPlaceholder={ARC_FILTERING_PLACEHOLDER}
      header={
        <Header variant="h2" counter={`(${rates.length})`}>
          Generated rates
        </Header>
      }
      empty="No generated rates."
    />
  );
};

export default PricingModelPreview;
